<template>
    <v-list
        v-model:opened="opened"
        open-strategy="multiple"
        select-strategy="single-independent"
        @update:selected="(onSelect as any)"
    >
        <v-list-group
            v-for="item in items"
            :key="`market-${item.uid}}`"
            :value="item"
        >
            <template #activator="{ props }">
                <v-list-item
                    v-bind="props"
                    :title="item.name"
                ></v-list-item>
            </template>

            <v-list-item
                :value="item"
                :title="`All ${item.name}`"
            ></v-list-item>
            
            <v-list-group
                v-for="subItem in item.categories"
                :key="`category-${subItem.uid}`"
                :value="subItem"
            >
                <template #activator="{ props }">
                    <v-list-item
                        v-bind="props"
                        :value="subItem"
                        :title="subItem.name"
                    ></v-list-item>
                </template>
                <v-list-item
                    :value="subItem"
                    :title="`All ${subItem.name}`"
                ></v-list-item>
                <v-list-item
                    v-for="subSubItem in subItem.products"
                    :key="subSubItem.uid"
                    :value="subSubItem"
                    :title="subSubItem.name"
                ></v-list-item>
            </v-list-group>
        </v-list-group>
    </v-list>
</template>

<script lang="ts" setup>
    import type {
        ProductMarket,
        ProductCatalogMenuSelection,
        ProductCategory,
        Product
    } from '~/types';
    
    defineProps({
        items: {
            type: Array as PropType<ProductMarket[]>,
            required: true
        }
    });

    const emit = defineEmits<{
        'on-select': [value: Nullable<ProductCatalogMenuSelection>];
    }>();

    const opened = ref<string[]>([]);

    function onSelect(paths: (ProductMarket & ProductCategory & Product)[]): void {
        let currentSelected: Nullable<ProductCatalogMenuSelection> = null;

        if (paths.length) {
            const item = paths[0];
            currentSelected = {
                name: item?.name!,
                uid: item?.uid!,
                path: item?.path!
            };
        }

        emit('on-select', currentSelected);
    }
</script>

<style lang="scss"></style>
